import type Luminary from '@lumen5/luminary';

import { checkpointVideo } from 'js/src/data/video-data';
import uuid from 'js/src/libs/uuid';
import { saveRawLuminary } from 'js/src/luminary/index';
import {
    createLuminaryOperation,
    type LuminaryOperationContext,
} from 'js/src/luminary/luminary-hooks';
import { isLuminaryEmpty } from 'js/src/luminary/luminary-selectors';

export const addTemplateFontsOperation = createLuminaryOperation(
    (
        { luminary, dispatch }: LuminaryOperationContext<Luminary>,
        fontUrls: readonly string[],
        systemTriggered = false,
        parentActionGroup = uuid(),
    ) => {
        luminary.batchRun((safeLuminary) => {
            safeLuminary.template.fonts = [...safeLuminary.template.fonts, ...fontUrls];
        });
        if (!isLuminaryEmpty(luminary)) {
            dispatch(
                checkpointVideo({
                    video_data: saveRawLuminary(luminary),
                    systemTriggered,
                    parentActionGroup,
                }),
            );
        }
    },
);
